import React from 'react';
import './Services.css';
import { FaCode, FaMobileAlt, FaCloud, FaPencilRuler, FaServer, FaChartLine } from 'react-icons/fa';

const services = [
  {
    icon: <FaCode />,
    title: 'Web Development',
    desc: 'Modern, responsive websites and web applications built with React, Node.js, and the latest technologies.',
  },
  {
    icon: <FaMobileAlt />,
    title: 'Mobile App Development',
    desc: 'Cross-platform iOS and Android apps that deliver seamless, high-performance user experiences.',
  },
  {
    icon: <FaCloud />,
    title: 'Cloud Solutions',
    desc: 'Scalable cloud infrastructure, migration, and DevOps services on AWS, Azure, and Google Cloud.',
  },
  {
    icon: <FaPencilRuler />,
    title: 'UI/UX Design',
    desc: 'User-centric design that blends aesthetics with intuitive functionality to delight your users.',
  },
  {
    icon: <FaServer />,
    title: 'Enterprise Software',
    desc: 'Robust, scalable enterprise systems and ERP integrations tailored to your business workflows.',
  },
  {
    icon: <FaChartLine />,
    title: 'IT Consulting',
    desc: 'Strategic technology guidance to help you make the right decisions and accelerate growth.',
  },
];

function Services() {
  return (
    <section className="services" id="services">
      <h2>What We Do</h2>
      <p className="services-subtitle">End-to-end IT solutions designed to move your business forward.</p>
      <div className="services-grid">
        {services.map((service, index) => (
          <div className="service-card" key={index}>
            <div className="service-icon">{service.icon}</div>
            <h3>{service.title}</h3>
            <p>{service.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Services;
